import React from 'react';
import {CartItemType} from "../../model/store";
import {StyledItemCard} from "./style";
import goodsImg from "../../../../shared/image/dev/goods.png"
import ProductPriceWrap from "../../../../shared/ui/price/ProductPriceWrap";
import ProductOldPrice from "../../../../shared/ui/price/ProductOldPrice";
import ProductCurrentPrice from "../../../../shared/ui/price/ProductCurrentPrice";
import CartGoodsQuantity from "../quantity/CartGoodsQuantity";
import CartRemoveGoods from "../cartRemove/CartRemoveGoods";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

interface IProps {
    itemCart: CartItemType
}

const ItemCart: React.FC<IProps> = ({itemCart}) => {
    return (
        <StyledItemCard className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item')}>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-head')}>
                <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-head-img')}>
                    <img src={goodsImg} alt=""/>
                </div>
                <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-head-title')}>
                    {itemCart.name}
                </div>
            </div>

            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details')}
            >

                <CartGoodsQuantity key={'cart-goods-quantity' + itemCart.id} id={itemCart.id}/>

                <ProductPriceWrap className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-price')}>
                    <ProductOldPrice
                        className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-price-old')}>
                        12$
                    </ProductOldPrice>
                    <ProductCurrentPrice
                        className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-price-current')}>
                        {Math.round(((itemCart.price) * Number(itemCart.quantity)) * 100) / 100} $
                    </ProductCurrentPrice>
                </ProductPriceWrap>
                <CartRemoveGoods id={itemCart.id}/>
            </div>


        </StyledItemCard>
    );
};

export default ItemCart;